var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ml90",domProps:{"innerHTML":_vm._s(_vm.getLanguage == 'zh' ? _vm.businessSpecificationObj?.specificationCn : _vm.businessSpecificationObj?.specification)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }